import { cn } from '@/lib/cn'
import type { HTMLAttributes } from 'react'

/**
 * Inline keyboard shortcut hint. Pairs with buttons/menu items
 * (e.g. <Button>Rechercher <Kbd>⌘K</Kbd></Button>).
 */
export function Kbd({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-[1.25rem] select-none items-center justify-center gap-0.5 rounded border border-border bg-muted px-1.5 text-[10px] font-medium leading-none text-muted-foreground',
        className,
      )}
      {...props}
    />
  )
}

/** Platform-aware command key symbol (⌘ on macOS, Ctrl elsewhere). */
export const META_KEY =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform) ? '⌘' : 'Ctrl'
